import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { AdminPage } from './pages/AdminPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/quienes-somos" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/proyectos" element={<ProjectsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/admin" element={<AdminPage data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}